<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .paragraph-product-cards-exp

        &__container
            +container2

        &__items
            display: flex
            flex-direction: row
            justify-content: center
            flex-wrap: nowrap
            +media("<=768px")
                display: block

        &__item
            flex-basis: 33.333333%
            max-height: 18rem
            display: flex
            flex-direction: column
            align-items: center
            padding: 0 3rem
            border: 1px solid $color-gray-medium
            position: relative
            transition: max-height $speed-normal $authentic-motion-out
            overflow: hidden
            cursor: pointer
            +media("<=1024px")
                padding: 0 2rem
            +media("<=768px")
                display: block
                margin-bottom: 1rem
                margin-left: 0 !important
                max-height: 6rem
                text-align: left
                padding-left: 1rem
                padding-right: 3.5rem
            +media("<=320px")
                padding-right: 3rem
                font-size: 0.8rem

            &:hover .paragraph-product-cards-exp__item__arrow
                transform: translateY(0.5rem) rotate(0deg)

            &.open
                max-height: 30rem
            &.open:hover .paragraph-product-cards-exp__item__arrow
                transform: translateY(-0.5rem) rotate(180deg)

            & + &
                margin-left: 2rem

            &__top
                pointer-events: none
                +media("<=768px")
                    display: flex
                    flex-direction: row
                    align-content: center
                    align-items: center
                    width: 100%

            &__icon-wrapper
                margin-top: 3rem
                height: 6rem
                display: flex
                justify-content: center
                flex-direction: column
                margin-bottom: 1rem
                align-items: center
                +media("<=768px")
                    height: 3rem
                    margin-top: 1.5rem
                    margin-right: 0.5rem

            &__icon
                height: 5rem
                width: 5rem
                +media("<=768px")
                    height: 3rem
                    width: 3rem

            &__head
                text-align: center
                line-height: 1.4
                opacity: 0.8
                height: 8rem
                +media("<=768px")
                    height: auto
                    text-align: left
                &__title
                    +media("<=600px")
                        font-size: 0.8rem
                        font-weight: 500
                &__subtitle
                    font-size: 0.9rem
                    +media("<=600px")
                        font-size: 0.7rem


            &__arrow
                position: absolute
                background-image: url(../../common/graphics/arrow-down.svg)
                background-size: contain
                background-position: center
                background-repeat: no-repeat
                transition: transform $speed-normal $authentic-motion-out
                transform-origin: center
                width: 1.5rem
                height: 1.5rem
                top: 15rem
                left: calc(50% - 0.75rem)
                +media("<=768px")
                    right: 1.5rem
                    left: auto
                    top: 2.5rem
                +media("<=320px")
                    right: 0.75rem


                .open &
                    transform: rotate(180deg)

            &__bullets
                pointer-events: none
                width: 100%
                text-align: left
                font-size: 0.9rem
                margin-bottom: 2rem
                transition: max-height $speed-normal $authentic-motion-out
                +media("<=320px")
                    font-size: 0.8rem

                li
                    margin-bottom: 1rem

                .open &
                    max-height: 10rem

</style>

<script>

    import $ from 'jquery'

    export default {

        methods: {

            toggle($event) {
                let $item = $($event.target);
                $item.toggleClass('open');
            }


        }


    }

</script>
